import React from "react";
import PropTypes from "prop-types";
import Grid from "@material-ui/core/Grid";
import { withStyles } from "@material-ui/core/styles";
import { ShowToolBar } from "components/UI/ToolBars";

const styles = theme => ({
  root: {
    flexGrow: 1,
  },
  toolbar: {
    marginBottom: theme.spacing.unit * 3,
  }
});

class ShowLayout extends React.Component {
  render() {
    const {
      classes,
      moduleName,
      actions,
    } = this.props;

    return (
      <div className={classes.root}>
        <div className={classes.toolbar}>
          <ShowToolBar
            moduleName={moduleName}
            actions={actions}
          />
        </div>

        <Grid container spacing={24}>
          <Grid item xs={12} sm={12}>
            {this.props.children}
          </Grid>
        </Grid>
      </div>
    );
  }
}

ShowLayout.propTypes = {
  moduleName: PropTypes.string.isRequired,
  children: PropTypes.node,
};

export default withStyles(styles)(ShowLayout);
